import classNames from 'classnames';
import { FC } from 'react';
import Avatar, { AvatarProps } from '../../../../../../ReactSharedScripts/components/Avatar';
import classes from './styles/index.module.scss';

type SpreadsheetPreloadingAvatarProps = {
	className?: string;
} & Pick<AvatarProps, 'size'>;

export const SpreadsheetPreloadingAvatar: FC<SpreadsheetPreloadingAvatarProps> = ({ className, size }) => {
	const componentClasses = classNames(classes.spreadsheetAvatar, className);

	return (
		<div className={componentClasses}>
			<Avatar
				initials='...'
				size={size}
			/>
		</div>
	);
};
